<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form #form="ngForm" [formGroup]="addPhoneNumber" (ngSubmit)="onSubmit()">
    <div mat-dialog-content>
      <div class="phone-number-container">
        <div class="inline-form first">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.CHOOSE_AREA_CODE" | translate }}</div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="areaCode" name="areaCode">
              @for (npaNxx of npaNxxs; track npaNxx) {
              <mat-option [value]="npaNxx.num">
                {{ getNpaDescription(npaNxx) | titlecase }} - {{ npaNxx.num }}
              </mat-option>
              }
            </mat-select>
            @if (addPhoneNumber.controls.areaCode.hasError('required')) {
            <mat-error>
              {{ "ONSIP_I18N.CHOOSE_AREA_CODE_REQUIRED" | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="inline-form seconds">
          <div class="mat-body-1 m-b-12">
            {{ "ONSIP_I18N.CHOOSE_LOCAL_PREFIX" | translate }}
            <mat-icon
              [matTooltip]="
                'ONSIP_I18N.ALSO_CALLED_A_RATE_CENTER_OR_EXCHANGE_CODE_THIS_IS_THE_FIRST_THREE_DIGITS_OF_A_STANDARD_SEVENDIGIT_PHONE_NUMBER'
                  | translate
              "
              matTooltipClass="onsip-tooltip-background"
              [matTooltipPosition]="'above'"
              >help_outline
            </mat-icon>
          </div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="localPrefix" name="localPrefix">
              @for (nxx of nxxs; track nxx) {
              <mat-option [value]="nxx.num">
                {{
                  (nxx.rateCenter ? nxx.rateCenter : ("ONSIP_I18N.UNKNOWN" | translate)) | titlecase
                }}
                - {{ nxx.num }}
              </mat-option>
              }
            </mat-select>
            @if (addPhoneNumber.controls.localPrefix.hasError('required')) {
            <mat-error>
              {{ "ONSIP_I18N.CHOOSE_LOCAL_PREFIX_REQUIRED" | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="name-container">
        <div class="mat-body-1 m-b-12">
          {{ "ONSIP_I18N.CHOOSE_DESTINATION" | translate }}
          <mat-icon
            [matTooltip]="
              'ONSIP_I18N.SELECTS_THE_USER_GROUP_OR_APPLICATION_TO_WHICH_INCOMING_CALLS_WILL_BE_ROUTED'
                | translate
            "
            matTooltipClass="onsip-tooltip-background"
            [matTooltipPosition]="'above'"
          >
            help_outline
          </mat-icon>
        </div>
        <onsip-address-autocomplete
          class="destination"
          [parentForm]="form"
          formControlName="destination"
          [errorMessage]="'ONSIP_I18N.CHOOSE_DESTINATION_REQUIRED' | translate"
        >
        </onsip-address-autocomplete>
      </div>
      <div class="caller-id-container">
        <div class="inline-form">
          <mat-checkbox
            class="no-caller-id mat-body-1"
            formControlName="noCallerId"
            name="noCallerId"
            color="primary"
          >
            <span class="caller-id-text"
              >{{ "ONSIP_I18N.BLOCK_INCOMING_CALLS_WITH_NO_CALLER_ID" | translate }}&nbsp;</span
            >
          </mat-checkbox>
          <mat-icon
            [matTooltip]="
              'ONSIP_I18N.AUTOMATICALLY_REJECTS_AN_INCOMING_CALL_IF_IT_THE_CALLERS_ID_IS_BLOCKED'
                | translate
            "
            matTooltipClass="onsip-tooltip-background"
            [matTooltipPosition]="'above'"
          >
            help_outline
          </mat-icon>
        </div>
      </div>
      <div class="phone-number-container">
        <div class="inline-form first">
          <div class="mat-body-1 m-b-12">
            {{ "ONSIP_I18N.OUTBOUND_CALLER_ID_NAME" | translate }}
            <mat-icon
              [matTooltip]="
                ('ONSIP_I18N.CHOOSE_WHAT_TO_DISPLAY_AS_YOUR_CALLER_ID_WHEN_MAKING_OUTBOUND_CALLS'
                  | translate) +
                ' (' +
                ('ONSIP_I18N.OPTIONAL' | translate) +
                ')'
              "
              matTooltipClass="onsip-tooltip-background"
              [matTooltipPosition]="'above'"
            >
              help_outline
            </mat-icon>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>{{ "ONSIP_I18N.OUTBOUND_CALLER_ID_NAME" | translate }}</mat-label>
            <input
              [placeholder]="'ONSIP_I18N.OUTBOUND_CALLER_ID_NAME' | translate"
              matInput
              formControlName="callerIdName"
              name="callerIdName"
              type="text"
            />
          </mat-form-field>
        </div>
        <div class="inline-form seconds">
          <div class="mat-body-1 m-b-12">
            {{ "ONSIP_I18N.ASSIGN_CALL_DETAIL_REPORT_TO" | translate }}
            <mat-icon
              [matTooltip]="
                'ONSIP_I18N.CALL_DETAIL_REPORT_FOR_THIS_NUMBER_WILL_BE_ASSIGNED_TO_THE_SELECTED_USER_IT_IS_ASSIGNED_TO_THE_ACCOUNT_ADMIN_BY_DEFAULT_AND_CAN_BE_CHANGED_OPTIONALLY'
                  | translate
              "
              matTooltipClass="onsip-tooltip-background"
              [matTooltipPosition]="'above'"
            >
              help_outline
            </mat-icon>
          </div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="assignCallDetails" name="assignCallDetails">
              @for (user of users; track user) {
              <mat-option [value]="user.userId">
                {{ user.contact.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="page-view-controls">
      <button
        mat-button
        type="button"
        class="cancel"
        color="primary"
        (click)="closeAddNumberForm()"
      >
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button mat-flat-button type="submit" color="primary">
        {{ "ONSIP_I18N.SAVE" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
